import { render, staticRenderFns } from "./MerchandisingItemAliases.vue?vue&type=template&id=450c6e24"
import script from "./MerchandisingItemAliases.vue?vue&type=script&lang=js"
export * from "./MerchandisingItemAliases.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports